// extracted by mini-css-extract-plugin
export default {"wrapper":"iy2SN","btn":"uCcy6","active-btn":"pHfxa"};